<template>
  <ul class="configurator-step-extras">
    <li class="meta">
      <div v-on:click="submit" class="submit" v-wave="{color: '#54a324',initialOpacity: 0.3,easing: 'ease-in'}">Fertig ausgewählt</div>
    </li>

    <li v-if="emptyList" class="empty">Keine besonderen Ausstattungsmerkmale gefunden</li>

		<ConfiguratorStepExtrasItem
			v-for="(item, index) in options"
			v-bind:item="item"
			v-bind:option="name"
			v-bind:key="item.id" />
	</ul>
</template>

<script>
import ConfiguratorStepExtrasItem from './ConfiguratorStepExtrasItem'

export default {
  name: 'ConfiguratorStepExtras',
  components: { ConfiguratorStepExtrasItem },
  props: ['name', 'options'],
  data: function() {
    return {}
  },
  computed: {
    emptyList: function() {
      return this.options == null || this.options.length == 0;
    }
  },
  methods: {
    submit: function(event) {
      this.$store.dispatch('selectOption', {name: this.name});
    }
  }
}
</script>

<style lang="scss" scoped>

* {
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 transparent;
}
*:hover {
  scrollbar-width: thin;
  scrollbar-color: #999999 transparent;
}
*::-webkit-scrollbar {
  width: 8px;
}
*::-webkit-scrollbar-track {
  background: transparent;
}
*::-webkit-scrollbar-thumb {
  background-color: #c1c1c1;
  border-radius: 20px;
}
*::-webkit-scrollbar-thumb:hover {
  background-color: #999999;
}

ul {
	margin: 0;
	padding: 10px 0;
	list-style-type: none;
	position: absolute;
	top: 62px;
	left: 0;
	right: 0;
	bottom: 0;
	overflow-y: scroll;
}

li.meta {
  padding: 10px 20px 20px 20px;
}

li.empty {
  padding: 0 20px;
  color: #888;
  font-size: 12px;
  line-height: 20px;
}

.submit {
  display:block;
  border: 1px solid #54a324;
  color: #54a324;
  border-radius: 23px;
  padding: 10px;
  text-align: center;
  font-weight: 600;
  cursor: pointer;
  @media (hover: hover) {
    &:not(.disabled):hover {
      text-decoration: none;
      background-color: #eee;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/ConfiguratorStepExtras.vue